import { dsClass } from '../../common/constants/dsClasses.js';
import { companyMsg, contractPeriodMsg, monthMsg, productTypeMsg, t } from '../../common/i18n/index.js';
import { getDeviceSelectionProductTypeLabel } from '../../common/utils/deviceListTabsUtilsCoCo.js';
import { EMPTY_VALUE } from '../../common/utils/deviceListUtilsCoCo.js';
import { toDeviceSelectionProductType } from '../../common/utils/deviceSelectionListUtilsCoCo.js';
import { Table } from '../Table/index.js';
import type { CLTableColumn, CLTableRow } from '../../common/types/componentLibrary.js';
import type { EmployeeProductSelectionUsedInProductList } from '../../generated/api/employeeProductSelectionUsedInProductList.js';

const getColumns = (): CLTableColumn[] => [
  { key: 'name', label: t.IVJB('Name of device list'), width: '30%' },
  { key: 'productType', label: t.R6HP(productTypeMsg) },
  { key: 'contractPeriod', label: t.D55M(contractPeriodMsg) },
  { key: 'company', label: t.KJTS(companyMsg) },
];

interface DeviceSelectionUsedInDeviceListsCoCoProps {
  deviceLists?: EmployeeProductSelectionUsedInProductList[];
}

export const DeviceSelectionUsedInDeviceListsCoCo = ({
  deviceLists = [],
}: DeviceSelectionUsedInDeviceListsCoCoProps) => {
  if (deviceLists.length === 0) {
    return null;
  }

  const rows: CLTableRow[] = deviceLists.map(deviceList => ({
    name: deviceList.name || EMPTY_VALUE,
    productType: deviceList.productType
      ? getDeviceSelectionProductTypeLabel(toDeviceSelectionProductType(deviceList.productType))
      : EMPTY_VALUE,
    contractPeriod: deviceList.contractTerms?.length
      ? `${deviceList.contractTerms.join(', ')} ${t.XXVX(monthMsg)}`
      : EMPTY_VALUE,
    company: deviceList.companyName || EMPTY_VALUE,
  }));

  return (
    <section className="of-device-selection-details-coco__used-in">
      <h3 className={dsClass.H3}>{t.GGVK('Used in device lists')}</h3>
      <Table columns={getColumns()} rows={rows} valignText="top" />
    </section>
  );
};
